(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Storage", [], factory);
	else if(typeof exports === 'object')
		exports["Storage"] = factory();
	else
		root["Storage"] = factory();
})(this, function() {
return 